import Tables from 'src/class/Tables';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  const columns = [
    {
      prop: 'fortnight_name',
      label: i18n.t('labor.payment_frequency'),
      sortable: true,
      minWidth: 200,
    },
    {
      prop: 'worker_name',
      label: `${i18n.t('common_words.name')} ${i18n.t('labor.worker')}`,
      sortable: true,
      minWidth: 200,
    },
    {
      prop: 'document_id',
      label: i18n.t('common_words.document_cc'),
      minWidth: 180,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'worker_code',
      label: i18n.t('labor.worker'),
      minWidth: 120,
      sortable: true,
    },
    {
      prop: 'bonus_homologated_code',
      label: i18n.t('common_words.code_sap'),
      minWidth: 190,
      sortable: true,
    },
    {
      prop: 'farm_name',
      label: i18n.t('common_words.farm'),
      sortable: true,
      minWidth: 200,
    },
    {
      prop: 'days',
      label: `${i18n.t('common_words.working_days')}`,
      align: 'center',
      sortable: true,
    },
    {
      prop: 'bonus_value',
      label: i18n.t('common_words.value'),
      align: 'center',
      minWidth: 150,
      formatter: (row, column) => {
        return `$${Formatter.formatNumber(Number(row[column.property]))}`;
      },
    },
    {
      prop: 'total_bonus',
      label: i18n.t('common_words.total'),
      align: 'center',
      minWidth: 150,
      formatter: (row, column) => {
        return `$${Formatter.formatNumber(Number(row[column.property]))}`;
      },
    },
  ];

  Table.tableColumns = [...columns];

  const Table2 = { ...Tables.Table };

  Table2.tableColumns = [...columns];

  const Search2 = {
    pagedData2() {
      return this.tableData2.slice(this.from2, this.to2);
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData2() {
      let result = this.tableData2;
      if (this.searchedQuery2 !== '') {
        result = this.fuseSearch2.search('=' + this.searchedQuery2 + '');
      }
      this.pagination2.total = result.length;

      if (this.$refs.cardfooter2) {
        this.$refs.cardfooter2.totals = this.pagination2.total;
      }

      return result.slice(this.from2, this.to2);
    },
    to2() {
      let highBound = this.from2 + this.pagination2.perPage;
      if (this.total2 < highBound) {
        highBound = this.total2;
      }

      if (this.$refs.cardfooter2) {
        this.$refs.cardfooter2.tos = highBound;
      }

      return highBound;
    },
    from2() {
      let from = this.pagination2.perPage * (this.pagination2.currentPage - 1);
      if (this.$refs.cardfooter2) {
        this.$refs.cardfooter2.froms = from;
      }

      return from;
    },
    total2() {
      if (this.$refs.cardfooter2) {
        this.$refs.cardfooter2.totals = this.pagination2.total;
      }

      return this.pagination2.total;
    },
  };

  return { Table, Table2, Search2 };
};

export default configTable;
